import React from 'react';
import Grid from 'components/atoms/Grid';
import Field from 'components/molecules/Field';
import Form from 'components/molecules/Form';

function FaqsSection({ faqs, setFaqs }) {
  const addField = () => {
    setFaqs(prev => [
      ...prev,
      {
        question: '',
        answer: '',
      },
    ]);
  };

  const updateQuestion = (index, question) => {
    setFaqs(prev => {
      const updated = [...prev];
      updated[index].question = question;
      return updated;
    });
  };

  const updateAnswer = (index, answer) => {
    setFaqs(prev => {
      const updated = [...prev];
      updated[index].answer = answer;
      return updated;
    });
  };

  const removeField = index => {
    setFaqs(prev => prev.filter((_, i) => i !== index));
  };

  return (
    <div className="faqs-holder">
      <div className="head">
        <span className="label">FAQS</span>
        <button className="add-more" type="button" onClick={addField}>
          Add FAQ <i className="material-icons-outlined">add</i>
        </button>
      </div>
      <Grid xs={1} lg={2} colGap={10} rowGap={20}>
        {faqs?.map((faq, index) => (
          <div key={index} className="faq">
            <Form.Item
              label={`Question ${index + 1}`}
              name={`faq_question_${index + 1}`}
              type="text"
              sm
              value={faq?.question}
              onChange={e => {
                updateQuestion(index, e.target.value);
              }}
              rules={[{ required: false, message: 'Enter question' }]}>
              <Field />
            </Form.Item>
            <div className="product-description">
              <Form.Item
                label={`Answer ${index + 1}`}
                name={`faq_answer_${index + 1}`}
                type="textarea"
                value={faq?.answer}
                onChange={e => {
                  updateAnswer(index, e.target.value);
                }}
                rules={[{ required: false, message: 'Enter answer' }]}>
                <Field />
              </Form.Item>
            </div>
            {faqs.length > 1 && (
              <>
                <button className="remove-btn" onClick={() => removeField(index)}>
                  <i className="material-icons-outlined">close</i>
                </button>
              </>
            )}
          </div>
        ))}
      </Grid>
    </div>
  );
}

export default FaqsSection;
